/**
 * Created by pawel on 2017-02-10.
 */
(function ($) {

    $(document).ready(function () {

        // console.debug('Initialize pwForm observers');
        pw.doc('Form', '0.1.170516');

        $(document)
            .on('change', 'form[data-valid-partial] input, input[data-valid-partial]', function (e) {
                e.stopPropagation();

                var ui = $(this),
                    form = ui.parents('form').eq(0),
                    validPath = form.attr('data-valid-partial'),
                    uiValidPath = ui.attr('data-valid-partial'),
                    hasValid = false
                ;

                if (uiValidPath && /\//g.test(uiValidPath)) {
                    validPath = uiValidPath;
                    console.log('Valid element by custom path ', validPath);
                    hasValid = true;
                }
                if (!hasValid && ui.prop('required')) {
                    hasValid = true;
                }

                if (hasValid) {
                    ui.trigger('valid:text.pw', [ui, form, validPath]);
                } else {
                    console.info('This element not valid partial');
                }

            })
            .on('valid:text.pw', function (e, ui, form) {

                e.stopPropagation();
                console.log(ui, form);


            })
            .on('submit', 'form[data-pw="ajax"]', function (e) {

                e.preventDefault();
                var form = $(this),
                    idForm = form.attr('id'),
                    wrapper = form.parent(),
                    url = form.attr('action') || window.location,
                    method = form.attr('method') || 'POST',
                    files = form.find('[type="file"]'),
                    arp = {
                        url: url,
                        method: method,
                        data: {},
                        dataType: "html"
                    }
                ;


                if (idForm && !wrapper.hasClass('loading')) {

                    wrapper.addClass('loading');
                    // see https://stackoverflow.com/questions/166221/how-can-i-upload-files-asynchronously
                    if (files.length) {
                        arp.data = new FormData(form[0]);
                        arp.cache = false;
                        arp.contentType = false;
                        arp.processData = false;
                        arp.xhr = function () {
                            var myXhr = $.ajaxSettings.xhr();
                            return myXhr;
                        };
                    } else {
                        arp.data = form.eq(0).serialize();
                    }

                    console.debug('form[data-pw="ajax"]#' + idForm, arp);

                    $.ajax(arp)
                        .done(function (data) {

                            pw.ajaxContent.apply(e.target, [data, wrapper]);

                        }).fail(function (jqXHR, textStatus) {
                        console.error(textStatus);
                    });

                    console.debug('submit form ', idForm, form[0].checkValidity());

                } else {
                    console.error('Not found attr ID in this form');
                }
            })
        ;
    });

})(jQuery);